export const paths = {
  //! /root
  HOME: '/',
  DASHBOARD: '/dashboard',
  GIFT_CATALOG: '/gift-catalog',
  AI_GIFT_ASSISTANT: '/ai-gift-assistant',
  SIGN_IN: `/login`,
  SIGN_OUT: '/logout',
  SIGN_UP: `/sign-up`,
  VALIDATE: `/validate`,
  CREATE_ACCOUNT: `/create-account`,
  PROFILE: '/account',
  SELECT_ORGANIZATION: `/select-organization`,
  NOT_FOUND: '/not-found',
  ERROR: '/error',
  UNDER_MAINTENANCE: '/under-maintenance',

  LOGIN: (token, organizationCode) => `/login?token=${token}&organizationCode=${organizationCode}`,

  //! /invite
  INVITE_DETAIL: () => `/invite`,
  INVITE_EXPIRED: () => `/invite/expired`,

  //! /contacts
  CONTACTS: '/contacts',
  NEW_CONTACTS: '/contacts/new',
  CONTACT_TAGS: '/contacts/tags',
  CONTACT_DETAIL: (id = ':id') => `/contacts/detail/${id}`,

  //! /new-automation
  NEW_AUTOMATION_GIFTS: '/new-automation/gifts',
  NEW_AUTOMATION_RULES: '/new-automation/rules',
  NEW_AUTOMATION_RECIPIENTS: '/new-automation/recipients',
  NEW_AUTOMATION_EXPERIENCE: '/new-automation/experience',
  NEW_AUTOMATION_REVIEW_ACTIVE: (code = ':code') => `/new-automation/review-and-active/${code}`,
  NEW_AUTOMATION_ORDER_CONFIRMED: (automationId = ':automationId') =>
    `/new-automation/order-confirmed/${automationId}`,

  //! /my-automations
  MY_AUTOMATION_LIST: '/my-automations',
  MY_AUTOMATION_DETAIL: (code = ':code') => `/automation/${code}`,
  AUTOMATION_RECIPIENT_DETAIL: (code = ':code', orderCode = ':orderCode') =>
    `/automation/${code}/contacts/${orderCode}`,

  //! /new-recognition
  NEW_RECOGNITION_GIFTS: '/new-recognition/gifts',
  NEW_RECOGNITION_CONTACT_TYPE: '/new-recognition/sharing',
  NEW_RECOGNITION_RECIPIENTS: '/new-recognition/recipients',
  NEW_RECOGNITION_EXPERIENCE: '/new-recognition/experience',
  NEW_RECOGNITION_REVIEW_PAY: (recognitionCode = ':recognitionCode') =>
    `/new-recognition/review-and-pay/${recognitionCode}`,
  NEW_RECOGNITION_SHARE: (recognitionCode = ':recognitionCode') =>
    `/new-recognition/share/${recognitionCode}`,
  NEW_RECOGNITION_ORDER_CONFIRMED: (recognitionCode = ':recognitionCode') =>
    `/new-recognition/order-confirmed/${recognitionCode}`,

  //! /my-recognitions
  MY_RECOGNITIONS: '/my-recognitions',
  RECOGNITION_THANK_YOU_NOTES: '/my-recognitions/thank-you-notes',

  //! /recognition
  MY_RECOGNITION_DETAIL: (recognitionCode = ':recognitionCode') =>
    `/recognition/${recognitionCode}`,
  RECOGNITION_RECIPIENT_DETAIL: (recognitionCode = ':recognitionCode', orderId = ':orderId') =>
    `/recognition/${recognitionCode}/recipients/${orderId}`,

  //! /collections
  COLLECTIONS: () => '/collections',
  COLLECTIONS_FEATURED: () => '/collections/featured',
  COLLECTIONS_SAVED: () => '/collections/saved',
  COLLECTIONS_DETAIL: (collectionId = ':collectionId') => `/collections/${collectionId}`,
  COLLECTIONS_DETAIL_EDIT: (collectionId = ':collectionId') => `/collections/${collectionId}/edit`,

  //! /learning-center
  LEARNING_CENTER: '/learning-center',

  //! /gratitude-board
  GRATITUDE_BOARD: '/gratitude-board',

  //! /settings
  SETTINGS: '/settings',
  SETTINGS_ACCOUNT: '/settings/account',
  SETTINGS_BRANDING: '/settings/branding',
  SETTINGS_PAYMENT_METHODS: '/settings/payment-methods',
  SETTINGS_USERS: '/settings/users',
  SETTINGS_USERS_DETAIL: (id = ':userId') => `/settings/users/${id}`,

  // simplify send gift
  SEND_GIFT_OCCASIONS: '/send-gift/occasions',
  SEND_GIFT_CREATE_GIFT_LIST: '/send-gift/gift-list',
  SEND_GIFT_UPDATE_GIFT_LIST: (recognitionCode = ':recognitionCode') =>
    `/send-gift/${recognitionCode}/gift-list`,
  SEND_GIFT_REVIEW: (recognitionCode = ':recognitionCode') =>
    `/send-gift/${recognitionCode}/review`,
  SEND_GIFT_CHECKOUT: (recognitionCode = ':recognitionCode') =>
    `/send-gift/${recognitionCode}/checkout`,
  SEND_GIFT_CONFIRMATION: (recognitionCode = ':recognitionCode') =>
    `/send-gift/${recognitionCode}/confirmation`
};
